// extracted by mini-css-extract-plugin
export default {"avatarGroupContainer":"components-AvatarGroup-AvatarGroup-module__avatarGroupContainer--IfXxS","avatarContainer":"components-AvatarGroup-AvatarGroup-module__avatarContainer--MA9CG"};